import Reveal from "./Reveal";

const blocks = [
  {
    icon: "ri-cloud-line",
    title: "Cloud",
    desc: "Secure and scalable cloud solutions.",
  },
  {
    icon: "ri-wifi-line",
    title: "Connectivity",
    desc: "Reliable networks and business communications.",
  },
  {
    icon: "ri-restart-line",
    title: "Continuity",
    desc: "Backup, recovery, and business continuity solutions.",
  },
];

export default function Cloud() {
  return (
    <section id="cloud" className="py-20 md:py-28 bg-background-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal className="max-w-2xl">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            Cloud &amp; Infrastructure
          </span>
          <h2 className="mt-3 font-heading font-extrabold text-foreground-950 text-3xl md:text-4xl tracking-tight">
            Modern Infrastructure. Built for Your Business.
          </h2>
          <p className="mt-4 text-foreground-600 text-base md:text-lg leading-relaxed">
            Whether you're moving to the cloud, upgrading your network, improving collaboration,
            or modernizing your communications, we help you build a technology environment that is
            secure, scalable, and easy to manage.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {blocks.map((b, i) => (
            <Reveal key={b.title} delay={i * 100}>
              <div className="group h-full rounded-lg border border-background-200 bg-white p-8 text-center transition-all duration-300 hover:border-primary-300 hover:-translate-y-1 cursor-pointer">
                <span className="inline-flex w-14 h-14 rounded-full bg-primary-50 text-primary-600 items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                  <i className={`${b.icon} text-2xl`} />
                </span>
                <h3 className="mt-5 font-heading font-bold text-foreground-950 text-lg">
                  {b.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{b.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}